//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileMissingSteps from '~/components/Dashboard/ProfileMissingSteps'
import UserSkillsInventory from '~/components/Dashboard/User/UserSkillsInventorySection.vue'
import UserOpportunities from '~/components/Dashboard/User/UserOpportunitiesSection.vue'

const STEPS = ['experience']
const NUM_OPPORTUNITIES = 4
export default {
  components: {
    UserOpportunities,
    ProfileMissingSteps,
    UserSkillsInventory,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  async fetch() {
    this.$store.commit('loading', true)
    this.stepProgress = await this.getProgress()
    this.stepsIncomplete = STEPS.filter(this.isIncomplete)
    this.registerComplete = this.stepsIncomplete.length === 0
    this.$emit('complete', this.registerComplete)
    this.opportunities = await this.fetchOpportunities()
    this.$store.commit('loading', false)
  },
  data() {
    return {
      stepProgress: {},
      routes: {
        profile: '/perfil',
        experience: '/experiencias',
        tests: '/tests',
      },
      stepsIncomplete: [],
      registerComplete: false,
      opportunities: [],
    }
  },
  methods: {
    isIncomplete(field) {
      return (
        this.stepProgress[field] < 100 &&
        !(field === 'profile' && this.$store.getters['me/hasConfirmed'])
      )
    },
    async getProgress() {
      const experienceProgress = await this.checkExperienceProgress()
      return {
        experience: Math.floor(experienceProgress),
      }
    },
    async checkExperienceProgress() {
      const {
        educationalCount,
        workCount,
        otherCount,
      } = await this.$repository.user.countExperiences(this.user.id)

      return educationalCount + workCount + otherCount > 0 ? 100 : 0
    },
    async fetchOpportunities() {
      return await this.$repository.user.getOpportunitiesMetaByUserId(
        this.user.id,
        NUM_OPPORTUNITIES
      )
    },
  },
}
